export const truncate = (source, size) => {
    return source.length > size ? source.slice(0, size - 1) + "…" : source;
}

export const truncateSentences = (text, numSentences) => {
    if (!text) return '';
    const sentences = text.match(/[^.!?]+[.!?]+/g) || [text];
    return sentences.slice(0, numSentences).join(' ').trim() + (sentences.length > numSentences ? '...' : '');
};
